import { render, staticRenderFns } from "./demoSystemLogin.vue?vue&type=template&id=59c2ef70&scoped=true&"
import script from "./demoSystemLogin.vue?vue&type=script&lang=js&"
export * from "./demoSystemLogin.vue?vue&type=script&lang=js&"
import style0 from "./demoSystemLogin.vue?vue&type=style&index=0&id=59c2ef70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c2ef70",
  null
  
)

export default component.exports